import axios from "@main/axios";
import {logger} from "@main/helpers/logger";

let isInProgress = false;

export default async function getPublicationSlides(el, slider, url, size) {

    const wrapper = el.querySelector(".swiper-wrapper");
    const isEnd = el.hasAttribute("data-slider");
    const paginator = el.dataset.paginator || "PAGEN_1";
    const page = el.dataset.page;

    if(!url || !el || !slider) {
        return;
    }

    try {
        if(isInProgress ||
            isEnd) {
            return;
        }

        isInProgress = true;

        const response = await axios({
            url: url,
            method: "GET",
            params: {
                size: size,
                [paginator]: page,
            },
        });

        isInProgress = false;
        
        const dataPublications = response.data.data.publications;

        dataPublications.forEach((publ) => {
            const publicationCard = 
            `<a href="${publ.HREF}" ${publ.TARGET} class="publication publications__slide swiper-slide">
                <img class="publication__image" src="${publ.IMAGE}" alt="${publ.TITLE}" loading="lazy">
                <div class="publication__title">${publ.TITLE}</div>
                <p class="publication__text">${publ.TEXT}</p>
            </a>`;
            wrapper.insertAdjacentHTML("beforeend", publicationCard);
        }); 
        slider.update();
        el.setAttribute("data-page", Number(page) + 1);

        const pageCount = response.data.data.pageCount;
        
        if (page == pageCount) {
            el.setAttribute("data-slider", "end");
        }

    } catch (e) {
        logger.log(e);
        alert("Что-то пошло не так...\nПопробуйте обновить страницу");
    }
}
